import type { SVGProps } from 'react';

/** Figma `sort-vertical.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const SortVerticalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.667 4.8125C14.853 4.8125 15.0311 4.88787 15.1606 5.0214L18.8272 8.80265C19.0915 9.07523 19.0848 9.51048 18.8123 9.77481C18.5397 10.0391 18.1044 10.0324 17.8401 9.75985L15.3545 7.19656L15.3545 16.5C15.3545 16.8797 15.0467 17.1875 14.667 17.1875C14.2873 17.1875 13.9795 16.8797 13.9795 16.5L13.9795 7.19657L11.4939 9.75985C11.2296 10.0324 10.7943 10.0391 10.5217 9.77481C10.2491 9.51048 10.2424 9.07523 10.5068 8.80265L14.1734 5.0214C14.3029 4.88787 14.481 4.8125 14.667 4.8125ZM7.33366 4.8125C7.71336 4.8125 8.02116 5.1203 8.02116 5.5L8.02116 14.8034L10.5068 12.2401C10.7711 11.9676 11.2063 11.9609 11.4789 12.2252C11.7515 12.4895 11.7582 12.9248 11.4939 13.1974L7.82722 16.9786C7.69773 17.1121 7.51966 17.1875 7.33366 17.1875C7.14766 17.1875 6.96959 17.1121 6.8401 16.9786L3.17344 13.1974C2.90911 12.9248 2.91581 12.4895 3.18839 12.2252C3.46098 11.9609 3.89623 11.9676 4.16055 12.2402L6.64616 14.8034L6.64616 5.5C6.64616 5.1203 6.95396 4.8125 7.33366 4.8125Z"
      fill="#E58C1A"
    />
  </svg>
);
